import React from 'react';
import { useSelector } from 'react-redux';
import { FlexibleCol, GridWrapper, Row } from '@yme/atoms/grid';
import { IndentWrapper } from '@yme/components/Separator';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { CardForEvents } from '@yme/molecules/cards/card-for-events';
import { SectionWrapper } from '@yme/molecules/section-wrapper';
import { getCommonLabels, getRTL } from '@yme/selectors/index';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { BREAKPOINT } from '@yme/tokens/screen';
import { HeadingLevel2 } from '@yme/tokens/typography';
import { buildKey } from '@yme/utils/common';
import { AspectRatio, AspectRatio as AspectRatioParams } from '@yme/utils/constants';
import { WhatToReadNextCarousel } from './WhatToReadNextCarousel';
import { WHAT_READ_NEXT_CARD_HEIGHT } from './constants';
import { isWhatToReadNextCardEmpty, prepareCaption } from './helpers';
export function WhatToReadNext(props) {
    const { cards = [], title, isRemoveBottomIndent } = props;
    const isRightToLeft = useSelector(getRTL);
    const labels = useSelector(getCommonLabels);
    const { isMobileView } = useWindowSize();
    const prepareCards = cards.filter((card) => !isWhatToReadNextCardEmpty(card));
    const finalData = prepareCards.map((card) => ({
        image: card.image,
        title: card.title,
        description: card.description,
        link: card.link,
        caption: prepareCaption(card.date, card.dateFrom, card.dateTo),
        additionalCaption: card.locationTitle,
        labelLink: labels?.common_readMore_link || '',
        countLineVisible: 'initial',
        aspectRatio: AspectRatio.RectangleLevel3,
        isContainSkeleton: true,
    }));
    if (!prepareCards.length) {
        return null;
    }
    if (isMobileView) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(GridWrapper, null,
                React.createElement(FlexWrapper, { isRightToLeft: isRightToLeft, flexDirection: "column" },
                    React.createElement(FlexWrapper, { alignSelf: "start", mb: "24px", mbTablet: "24px", mbDesktop: "32px" },
                        React.createElement(HeadingLevel2, { color: colorCoreBlack900Base }, title)),
                    React.createElement(WhatToReadNextCarousel, { cardProps: finalData, isRightToLeft: isRightToLeft })))));
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(SectionWrapper, { width: "100%", isExpanded: false, maxWidth: `${BREAKPOINT.xlg}px`, headerLeftSide: title, isRightToLeft: isRightToLeft },
            React.createElement(Row, null, finalData.map((data, index) => (React.createElement(FlexibleCol, { key: buildKey(data.title, index), lg: 4, md: 4 },
                React.createElement(CardForEvents, { cardProps: {
                        image: data?.image,
                        title: data.title,
                        description: data.description || '',
                        link: data.link,
                        labelLink: data.labelLink,
                        caption: data.caption,
                        additionalCaption: data.additionalCaption,
                        aspectRatio: AspectRatioParams.RectangleLevel3,
                        height: WHAT_READ_NEXT_CARD_HEIGHT,
                        countLineVisible: data.countLineVisible,
                        isFullHeaderVisible: true,
                    }, isRightToLeft: isRightToLeft }))))))));
}
WhatToReadNext.displayName = 'WhatToReadNext_AEMComponent';
